import type { ReactNode } from "react";
import {
  FormProvider,
  type FieldValues,
  type SubmitErrorHandler,
  type SubmitHandler,
  type UseFormReturn,
} from "react-hook-form";

import { cn } from "@/shared/lib/utils";

export function ColocaForm<T extends FieldValues>({
  form,
  onSubmit,
  onInvalid,
  children,
  className,
  id,
}: {
  form: UseFormReturn<T>;
  onSubmit: SubmitHandler<T>;
  /** Runs instead of `onSubmit` when validation refuses the values — e.g. to draw attention to the field. */
  onInvalid?: SubmitErrorHandler<T>;
  children: ReactNode;
  className?: string;
  /** HTML form id. Use with `<button form="id">` to wire a submit button that lives outside this form. */
  id?: string;
}) {
  return (
    <FormProvider {...form}>
      <form id={id} onSubmit={form.handleSubmit(onSubmit, onInvalid)} className={cn("space-y-6", className)}>
        {children}
      </form>
    </FormProvider>
  );
}
